export enum TagTypes {
  Hierarchy = 'Hierarchy',
  Advanced = 'Advanced',
  Date = 'Date',
}

export enum SourceType {
  Hierarchy = 'Hierarchy',
  OtherFilters = 'OtherFilters',
  Calendar = 'Calendar',
  DataDrivenFilters = 'DataDrivenFilters',
}

export type FilterBarValue = {
  DimName?: string;
  Tag?: TagTypes;
  DisplayName?: string;
  DimId?: number;
  AttributeGuid?: string;
  AttributeName?: string;
  Op1?: string | null;
  Op2?: string | null;
  OpType?: string;
  SubAttribute?: string;
  Source?: SourceType;
  Values?: string[];
  index?: number;
};

export type DataDrivenFilterFilterBarCacheModelChoice = {
  FieldGuid: string;
  Values: any;
};

export type DataDrivenFilterFilterBarCacheModelType = {
  PartitionGuid: string;
  Options: DataDrivenFilterFilterBarCacheModelChoice[];
};

export type FilterBarCacheModelType = {
  FilterBarValues?: FilterBarValue[];
  DataDrivenFilterValues?: DataDrivenFilterFilterBarCacheModelType[];
  HierarchyGUID?: string;
  AdvancedFiltersGUID?: string;
  DateButtonSelected?: string;
  SelectedFavoriteId?: string;
  Weight?: number;
  CacheVersion?: string;
  WorkspaceId?: string;
  idWorkspace?: string;
};
